import { useContext } from "react";
import { KnowledgeHubStateContext } from "../components/context/knowledge-hub-state-context";
import { usePatchableState } from "./use-patchable-state";
export var useKnowledgeHubState = function useKnowledgeHubState() {
  return usePatchableState(useContext(KnowledgeHubStateContext));
};